export default {
  'component.globalHeader.search': 'Rechercher',
  'component.globalHeader.search.example1': 'Exemple de recherche 1',
  'component.globalHeader.search.example2': 'Exemple de recherche 2',
  'component.globalHeader.search.example3': 'Exemple de recherche 3',
  'component.globalHeader.help': 'Aide',
  'component.globalHeader.notification': 'Notification',
  'component.globalHeader.notification.empty': 'Vous avez vu toutes les notifications.',
  'component.globalHeader.message': 'Message',
  'component.globalHeader.message.empty': 'Vous avez vu tous les messages.',
  'component.globalHeader.event': 'Événement',
  'component.globalHeader.event.empty': 'Vous avez vu tous les événements.',
  'component.noticeIcon.clear': 'Effacer',
  'component.noticeIcon.cleared': 'Effacé',
  'component.noticeIcon.empty': 'Aucune notification',
  'component.noticeIcon.view-more': 'Voir plus',
};
